import { OPEN_ID_ERROR_CODES_BY_REASON } from './open-id-error-reasons';
const REASONS = Object.keys(OPEN_ID_ERROR_CODES_BY_REASON);
/**
 * Narrows the `error` an OpenID Connect provider redirected back with to a reason we can show.
 *
 * The provider also sends a free-text `error_description`, which we deliberately never display.
 * `/openid/redirect` is reachable without logging in, so anything rendered from its query string is
 * text an attacker can put on a Famly-branded page under our own domain and certificate — a
 * phishing surface, the classic payload being a fake support phone number. The `error` code is safe
 * by contrast because it comes from a closed set, so it can only ever select one of our own
 * messages. Anything outside that set is reported as `unknown`.
 *
 * @param error The raw `error` query parameter, if the provider sent one
 * @returns The reason to show, or `unknown` for anything the specs do not define
 */
export const getOpenIdErrorReason = (error) => {
    // `error` is typed as a string, but `useQueryParams` returns an array when a key is repeated in
    // the url, and a one-element array coerces to a matching string in a looser comparison.
    if (typeof error !== 'string') {
        return 'unknown';
    }
    const reason = REASONS.find(candidate => OPEN_ID_ERROR_CODES_BY_REASON[candidate].includes(error));
    return reason !== null && reason !== void 0 ? reason : 'unknown';
};
